<template lang="pug">
#customer_service
  //- .nav_wrapper.d-flex.align-items-center
  //-   .scroll_sign.left(v-if="scrollLeftSide")
  //-     svg-icon(iconClass="triangle", className="triangle")
  //-   nav.scrollable_tab_nav(@scroll="scrollEvent")
  //-     .tabs.flex_h
  //-       router-link.tab_(
  //-         v-for="(tab, index) in customerServiceCommon.Menu",
  //-         tag="a",
  //-         :key="index",
  //-         :to="{ name: tab.pathName }"
  //-       )
  //-         scrollable-tab(
  //-           :key="index",
  //-           :title="tab.MenuTitle",
  //-           :img="tab.MenuIcon",
  //-           :selected="$route.name == tab.pathName"
  //-         )

  //-   .scroll_sign.right(v-if="scrollRightSide")
  //-     svg-icon(iconClass="triangle", className="triangle")
  .wrapper
    transition(name="page", mode="out-in")
      router-view
    custom-footer
</template>

<script>
import CustomFooter from "@/components/common/Footer";
import ScrollableTab from "@/components/customer_service/ScrollableTab";
import { getCustomerServiceCommon } from "@/json/customer_service";

export default {
  name: "CustomerService",
  components: {
    "custom-footer": CustomFooter,
    "scrollable-tab": ScrollableTab,
  },
  data() {
    return {
      customerServiceCommon: {},
      scrollLeftSide: false,
      scrollRightSide: true,
    };
  },
  created() {
    this.getCustomerServiceCommon();
  },
  methods: {
    getCustomerServiceCommon() {
      getCustomerServiceCommon().then((response) => {
        this.customerServiceCommon = response.data;
      });
    },
    scrollEvent(e) {
      if (e.srcElement.scrollLeft == 0) {
        this.scrollLeftSide = false;
      } else {
        this.scrollLeftSide = true;
      }

      if (
        Math.ceil(e.srcElement.scrollLeft) + e.srcElement.offsetWidth >=
        e.srcElement.scrollWidth
      ) {
        this.scrollRightSide = false;
      } else {
        this.scrollRightSide = true;
      }
    },
  },
  mounted() {},
  watch: {}
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/customer_service";
</style>
